import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'titlecasespace'
})
export class TitleCaseSpacePipe implements PipeTransform {

	transform(value: string, args?: any): any {
        value = value.replace(/([A-Z])([A-Z])([a-z])|([a-z])([A-Z])/g, '$1$4 $2$3$5').trim();
        return value.charAt(0).toUpperCase() + value.slice(1);
	}
}



// WEBPACK FOOTER //
// ./src/app/brightserve/pipes/title-case-space.pipe.ts